var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_cancel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_64px_icon",
    "data-name": "64px icon",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_2",
    "data-name": "\\uC0AC\\uAC01\\uD615 2",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,20V0H20V20Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19 19 L 19 1 L 1 1 L 1 19 L 19 19 M 20 20 L 0 20 L 0 0 L 20 0 L 20 20 Z",
    stroke: "none",
    fill: "#707070"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1250",
    "data-name": "\\uADF8\\uB8F9 1250",
    transform: "translate(-327.275 -615.775)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_109",
    "data-name": "\\uC120 109",
    x1: 8.551,
    y2: 8.551,
    transform: "translate(333 621.5)",
    fill: "none",
    stroke: "#a4a6ab",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_110",
    "data-name": "\\uC120 110",
    x2: 8.551,
    y2: 8.551,
    transform: "translate(333 621.5)",
    fill: "none",
    stroke: "#a4a6ab",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCancel);
export default __webpack_public_path__ + "static/media/ico_cancel.0889a2a8b1023ff66a1d62a35b7fa2ca.svg";
export { ForwardRef as ReactComponent };